import { TDeviceType } from '@cian/ui-kit';
import { FormEvent } from 'react';

export type TFormStatus = {
  status: EStatus;
};

export type TFetchFormParams = {
  phone: string;
  userId: number | null;
};

export enum EStatus {
  Initial = 'init',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export type TModalForm = {
  onClose?: VoidFunction;
  checkBoxRef: React.RefObject<HTMLInputElement>;
  phoneRef: React.RefObject<HTMLInputElement>;
  disabledButton: boolean;
  device: TDeviceType;
  onSendForm: (e: FormEvent<HTMLButtonElement>) => void;
  onFilledInput: VoidFunction;
  user: {
    phone: string;
  };
};

export interface IForm extends TModalForm {
  backToForm: VoidFunction;
}

export type TFormResponse = { status: string; message: string };
